/**
 * @file
 * Router Configuration
 * Used in library: vue-router
 *
 * Use this file to register the App routes
 * See https://router.vuejs.org/guide/#javascript
 * This configuration will be set in @/bootstrap/app.ts
 */

import {RouterOptions} from 'vue-router'

import DefaultPanelLayout from '@/views/layouts/DefaultPanelLayout.vue'

import SignInView from '@/views/auth/SignInView.vue'
import ResetPasswordView from '@/views/auth/ResetPasswordView.vue'
import RecoverPasswordView from '@/views/auth/RecoverPasswordView.vue'
import SignInFilialView from '@/views/auth/SignInFilialView.vue'

import CockpitView from '@/views/CockpitView.vue'

import TrackingView from '@/views/TrackingView.vue'

import DeliveryListView from '@/views/DeliveryListView.vue'
import DeliveryGetView from '@/views/get/DeliveryGetView.vue'
import DeliveryPersistView from '@/views/persist/DeliveryPersistView.vue'

import ManageDeliveryDriverView from '@/views/manage/ManageDeliveryDriverView.vue'
import ManageDeliveryRegisterView from '@/views/manage/ManageDeliveryRegisterView.vue'
import ManageDeliveryEndView from '@/views/manage/ManageDeliveryEndView.vue'
import ManagePersonTypeListView from '@/views/manage/ManagePersonTypeListView.vue'
import PersonTypePersistView from '@/views/persist/PersonTypePersistView.vue'
import UserPersistView from '@/views/persist/UserPersistView.vue'
import CheckListEntregaPersistView from '@/views/persist/CheckListEntregaPersistView.vue'
import CnpjBulklogPersistView from '@/views/persist/CnpjBulklogPersistView.vue'
import DriverPersistView from '@/views/persist/DriverPersistView.vue'
import ManageCompanyListView from '@/views/manage/ManageCompanyListView.vue'
import ManageDriverListView from '@/views/manage/ManageDriverListView.vue'
import ManageDriverTranshipmentListView from '@/views/manage/ManageDriverTranshipmentListView.vue'
import ManageAuditReasonListView from '@/views/manage/ManageAuditReasonListView.vue'
import AuditReasonPersistView from '@/views/persist/AuditReasonPersistView.vue'
import ManageSmsNotificationsSettingsView from '@/views/manage/ManageSmsNotificationsSettingsView.vue'
import ManageEmailNotificationsSettingsView from '@/views/manage/ManageEmailNotificationsSettingsView.vue'
import ManageWhatsappNotificationsSettingsView from '@/views/manage/ManageWhatsappNotificationsSettingsView.vue'
import ManageRotasSlaView from '@/views/manage/ManageRotasSlaView.vue'
import ManageOccurrenceTypeListView from '@/views/manage/ManageOccurrenceTypeListView.vue'
import ManageAlertListView from '@/views/manage/ManageAlertListView.vue'
import AlertPersistView from '@/views/persist/AlertPersistView.vue'
import ManageChecklistEntregaView from '@/views/manage/ManageChecklistEntregaView.vue'
import ManageCnpjBulklogView from '@/views/manage/ManageCnpjBulklogView.vue'
import ManageSucessOccurrenceTypeListView from '@/views/manage/ManageSucessOccurrenceTypeListView.vue'
import ManageAddresseeEmailView from '@/views/manage/ManageAddresseeEmailView.vue'
import ManageSettingsView from '@/views/manage/ManageSettingsView.vue'
import ManageCountersignView from '@/views/manage/ManageCountersignView.vue'
import ManageAwaitingAuditValidationView from '@/views/manage/ManageAwaitingAuditValidationView.vue'
import ReportsDeliveryMovementView from '@/views/reports/ReportsDeliveryMovementView.vue'
import ReportsDeliveryChecklist from '@/views/reports/ReportsDeliveryChecklist.vue'
import ReportsDeliveryIssueView from '@/views/reports/ReportsDeliveryIssueView.vue'
import ReportsDeliveryReceiverView from '@/views/reports/ReportsDeliveryReceiverView.vue'
import ReportsDeliveryShipperView from '@/views/reports/ReportsDeliveryShipperView.vue'
import ReportsDeliveryDriverView from '@/views/reports/ReportsDeliveryDriverView.vue'
import ReportsDeliveryMonthView from '@/views/reports/ReportsDeliveryMonthView.vue'
import ReportsDeliveryPeriodView from '@/views/reports/ReportsDeliveryPeriodView.vue'
import ReportsDeliveryVehicleView from '@/views/reports/ReportsDeliveryVehicleView.vue'
import ReportsDeliveryUfView from '@/views/reports/ReportsDeliveryUfView.vue'
import ReportsDeliveryCanceledView from '@/views/reports/ReportsDeliveryCanceledView.vue'
import ReportsDeliveryAlertHistoryView from '@/views/reports/ReportsDeliveryAlertHistoryView.vue'
// tslint:disable-next-line
import ReportsDeliverySatisfactionSurveyHistoryView from '@/views/reports/ReportsDeliverySatisfactionSurveyHistoryView.vue'
import ReportsDeliveryTrackingView from '@/views/reports/ReportsDeliveryTrackingView.vue'
import ReportsDeliveryAuditView from '@/views/reports/ReportsDeliveryAuditView.vue'
import ReportsDeliverySlaView from '@/views/reports/ReportsDeliverySlaView.vue'
import ReportsDeliveryEndedView from '@/views/reports/ReportsDeliveryEndedView.vue'
import ReportsDeliverySacView from '@/views/reports/ReportsDeliverySacView.vue'
import ReportsDeliverySacPublicView from '@/views/reports/ReportsDeliverySacPublicView.vue'
import ReportsDeliverySacPublicResultView from '@/views/reports/ReportsDeliverySacPublicResultView.vue'

import CssUsageSampleView from '@/views/sample/CssUsageSampleView.vue'
import ComponentUsageSampleView from '@/views/sample/ComponentUsageSampleView.vue'
import OccurrenceTypePersistView from '@/views/persist/OccurrenceTypePersistView.vue'
import OccurrenceTypeSucessPersistView from '@/views/persist/OccurrenceTypeSucessPersistView.vue'

import RelatorioGeracaoListView from '@/views/RelatorioGeracaoListView.vue'
import DeliveryGetCieloView from '@/views/get/DeliveryGetCieloView.vue'
import ReportsIRouteIndicatorView from '@/views/reports/ReportsIRouteIndicatorView.vue'
import ManageHideResponsavelNotasListView from '@/views/manage/ManageHideResponsavelNotasListView.vue'
import HideResponsavelNotasPersistView from '@/views/persist/HideResponsavelNotasPersistView.vue'
import DeliveryGetCteListView from '@/views/get/DeliveryGetCteListView.vue'
import ManageAuditEmailListView from '@/views/manage/ManageAuditEmailListView.vue'
import AuditEmailPersistView from '@/views/persist/AuditEmailPersistView.vue'
import ManageAwaitingAuditCorrectionListView from '@/views/manage/ManageAwaitingAuditCorrectionListView.vue'
import ManageRiskAreaListView from '@/views/manage/ManageRiskAreaListView.vue'
import RiskAreaPersistView from '@/views/persist/RiskAreaPersistView.vue'
import DriverConnectView from '@/views/persist/DriverConnectView.vue'
import ManageAlertDelayedNotasEmailView from '@/views/manage/ManageAlertDelayedNotasEmailView.vue'
import DeliveryGetNotasEmAtrasoListView from '@/views/get/DeliveryGetNotasEmAtrasoListView.vue'
import ReportsAuditByDeliveryView from '@/views/reports/ReportsAuditByDeliveryView.vue'
import ReportsDeliverySacAgcoPublicResultView from '@/views/reports/ReportsDeliverySacAgcoPublicResultView.vue'
import ReportsDeliverySacAgcoPublicView from '@/views/reports/ReportsDeliverySacAgcoPublicView.vue'
import ReportsClientNotificationView from '@/views/reports/ReportsClientNotificationView.vue'
import ReportsDeliverySacPublicIvecoResultView from '@/views/reports/ReportsDeliverySacPublicIvecoResultView.vue'
import ReportsDeliverySacIvecoPublicView from '@/views/reports/ReportsDeliverySacIvecoPublicView.vue'
import ReportsDeliverySacBostonPublicView from '@/views/reports/ReportsDeliverySacBostonPublicView.vue'
import ReportsDeliverySacBostonPublicResultView from '@/views/reports/ReportsDeliverySacBostonPublicResultView.vue'
import ManageHolidayListView from '@/views/manage/ManageHolidayListView.vue'
import HolidayPersistView from '@/views/persist/SlaHolidayPersistView.vue'
import ChangeTemporaryPasswordView from '@/views/auth/ChangeTemporaryPasswordView.vue'
import CodeValidation from '@/views/auth/CodeValidation.vue'
import ManageRespUserListView from '@/views/manage/ManageRespUserListView.vue'
import RespUserPersistView from '@/views/persist/RespUserPersistView.vue'

/**
 * VUE Router Configuration
 */
export const router: RouterOptions = {
  routes: [
    {
      path: '/sign-in',
      name: 'signIn',
      component: SignInView,
    },
    {
      path: '/password/reset',
      name: 'resetPassword',
      component: ResetPasswordView,
    },
    {
      path: '/sign-in/filial',
      name: 'signInFilial',
      component: SignInFilialView,
    },
    {
      path: '/code',
      name: 'validateCode',
      component: CodeValidation,
    },
    {
      path: '/password/change-temporary/',
      name: 'changeTemporaryPassword',
      component: ChangeTemporaryPasswordView,
    },
    {
      path: '/password/recover/:hash',
      name: 'recoverPassword',
      component: RecoverPasswordView,
      props: true,
    },
    {path: '/sac', name: 'sac', component: ReportsDeliverySacPublicView},
    {
      path: '/sac/dpk/result',
      name: 'sacDpk',
      component: ReportsDeliverySacPublicResultView,
    },
    {
      path: '/sac/havanna/result',
      name: 'sacHavanna',
      component: ReportsDeliverySacPublicResultView,
    },
    {
        path: '/sac/santillana/result',
        name: 'sacSantillana',
        component: ReportsDeliverySacPublicResultView,
    },
    {
      path: '/sac/cnhIveco',
      name: 'sacCnhIveco',
      component: ReportsDeliverySacIvecoPublicView,
    },
    {
      path: '/sac/cnhIveco/result',
      name: 'sacCnhIvecoResult',
      component: ReportsDeliverySacPublicIvecoResultView,
    },
    {
      path: '/sac/cnhIveco/direct',
      name: 'sacCnhIvecoDirect',
      component: ReportsDeliverySacPublicIvecoResultView,
    },
    {
      path: '/sac/agco',
      name: 'sacAgco',
      component: ReportsDeliverySacAgcoPublicView,
    },
    {
      path: '/sac/agco/result',
      name: 'sacAgcoResult',
      component: ReportsDeliverySacAgcoPublicResultView,
      props: true,
    },
    {
      path: '/sac/boston',
      name: 'sacBoston',
      component: ReportsDeliverySacBostonPublicView,
    },
    {
      path: '/sac/boston/result',
      name: 'sacBostonResult',
      component: ReportsDeliverySacBostonPublicResultView,
      props: true,
    },
    {path: '/sac/result', name: 'sacResult', component: ReportsDeliverySacPublicResultView},
    {path: '/sac/result/:type', name: 'sacResultType', component: ReportsDeliverySacPublicResultView, props: true},
    {path: '/delivery/get/:id/:hash', name: 'getDeliveryWithHash', component: DeliveryGetView, props: true},
    {
      path: '/delivery/getCargaEspecial/:id/:hash',
      name: 'getDeliveryCieloWithHash',
      component: DeliveryGetCieloView,
      props: true,
    },
    { path: '/delivery/cte/get/:id/:hash',
      name: 'getDeliveryCteView',
      component: DeliveryGetCteListView,
      props: true,
    },
    {
      path: '/delivery/getNotasEmAtraso/:hash',
      name: 'getNotasEmAtraso',
      component: DeliveryGetNotasEmAtrasoListView,
      props: true,
    },
    {
      path: '/cockpit',
      component: DefaultPanelLayout,
      children: [
        {path: '/cockpit', name: 'cockpit', component: CockpitView},
        {path: '/tracking', name: 'tracking', component: TrackingView},

        {path: '/delivery/list', name: 'listDelivery', component: DeliveryListView, props: true},
        {path: '/delivery/get/:id', name: 'getDelivery', component: DeliveryGetView, props: true},
        {path: '/delivery/new/:type', name: 'newDelivery', component: DeliveryPersistView, props: true},
        {path: '/delivery/edit/:id', name: 'editDelivery', component: DeliveryPersistView, props: true},

        {path: '/responsavel/edit/:id', name: 'editUser', component: UserPersistView, props: true},

        {path: '/driver/new', name: 'newDriver', component: DriverPersistView},
        {path: '/driver/connect', name: 'addDriver', component: DriverConnectView},
        {path: '/driver/edit/:id', name: 'editDriver', component: DriverPersistView, props: true},

        {path: '/occurrence-type/new', name: 'newOccurrenceType', component: OccurrenceTypePersistView},
        {
          path: '/occurrence-type/edit/:id',
          name: 'editOccurrenceType',
          component: OccurrenceTypePersistView,
          props: true,
        },

        {path: '/occurrence-type-sucess/new', name: 'newOccurrenceSucessType',
            component: OccurrenceTypeSucessPersistView},
        {
            path: '/occurrence-type-sucess/edit/:id',
            name: 'editOccurrenceSucessType',
            component: OccurrenceTypeSucessPersistView,
            props: true,
        },

        {path: '/checklist-entrega/new', name: 'newChecklistEntrega',
            component: CheckListEntregaPersistView},
        {
            path: '/checklist-entrega/edit/:id',
            name: 'editChecklistEntrega',
            component: CheckListEntregaPersistView,
            props: true,
        },

        {path: '/cnpj-bulklog/new', name: 'newCnpjBulklog',
            component: CnpjBulklogPersistView},
        {
            path: '/cnpj-bulklog/edit/:id',
            name: 'editCnpjBulklog',
            component: CnpjBulklogPersistView,
            props: true,
        },

        {path: '/relatorio-geracao', name: 'listRelatorioGeracao', component: RelatorioGeracaoListView},

        {path: '/indicador-iroute', name: 'reportIRoute', component: ReportsIRouteIndicatorView},

        {path: '/audit-reason/new', name: 'newAuditReason', component: AuditReasonPersistView},
        {path: '/audit-reason/edit/:id', name: 'editAuditReason', component: AuditReasonPersistView, props: true},

        {path: '/manage/delivery/driver', name: 'manageDeliveryDriver', component: ManageDeliveryDriverView},
        {path: '/manage/delivery/register', name: 'manageDeliveryRegister', component: ManageDeliveryRegisterView},
        {path: '/manage/delivery/end', name: 'manageDeliveryEnd', component: ManageDeliveryEndView},
        {path: '/manage/company/list', name: 'manageCompanyList', component: ManageCompanyListView},
        { path: '/manage/checklist-entrega/list', name: 'manageChecklistEntrega',
            component: ManageChecklistEntregaView},
          {
              path: '/manage/person-type/list',
              name: 'managePersonTypeList',
              component: ManagePersonTypeListView,
          },
          {
              path: '/person-type/edit/:id',
              name: 'editPersonType',
              component: PersonTypePersistView,
              props: true,
          },
          {
              path: '/person-type/new',
              name: 'newPersonType',
              component: PersonTypePersistView,
          },
        { path: '/manage/cnpj-bulklog/list', name: 'manageCnpjBulklog', component: ManageCnpjBulklogView},

          {path: '/manage/driver/list', name: 'manageDriverList', component: ManageDriverListView},
        {
          path: '/manage/driver/transhipment/list',
          name: 'manageDriverTranshipmentList',
          component: ManageDriverTranshipmentListView,
        },
        {
          path: '/manage/occurrence-type/list',
          name: 'manageOccurrenceTypeList',
          component: ManageOccurrenceTypeListView,
        },
        {
          path: '/manage/alert/list',
          name: 'manageAlertList',
          component: ManageAlertListView,
        },
        {
          path: '/alert/edit/:id',
          name: 'editAlert',
          component: AlertPersistView,
          props: true,
        },
        {
          path: '/alert/new',
          name: 'editAlertNew',
          component: AlertPersistView,
        },
        {
            path: '/manage/occurrence-type-sucess/list',
            name: 'manageOccurrenceTypeListSucess',
            component: ManageSucessOccurrenceTypeListView,
        },
        {path: '/manage/audit-reason/list', name: 'manageAuditReasonList', component: ManageAuditReasonListView},
        {
          path: '/manage/whatsapp-notification-settings',
          name: 'manageWhatsappNotificationSettings',
          component: ManageWhatsappNotificationsSettingsView,
        },
        {
          path: '/manage/sms-notification-settings',
          name: 'manageSmsNotificationSettings',
          component: ManageSmsNotificationsSettingsView,
        },
        {
          path: '/manage/email-notification-settings',
          name: 'manageEmailNotificationSettings',
          component: ManageEmailNotificationsSettingsView,
        },
        {path: '/manage/sla-table', name: 'manageSlaTable', component: ManageRotasSlaView},
        {
          path: '/manage/sla-holidays/list',
          name: 'manageHolidaysList',
          component: ManageHolidayListView,
        },
        {
          path: '/sla-holiday/new',
          name: 'newHoliday',
          component: HolidayPersistView,
        },
        {
          path: '/sla-holiday/edit/:id',
          name: 'editHoliday',
          component: HolidayPersistView,
          props: true,
        },
        {path: '/manage/addressee-email', name: 'manageAddresseeEmail', component: ManageAddresseeEmailView},
        {path: '/manage/settings', name: 'manageSettings', component: ManageSettingsView},
        {path: '/manage/countersign', name: 'manageCountersign', component: ManageCountersignView},
        {
          path: '/manage/alert-delayed-notas-email',
          name: 'manageAlertDelayedNotas',
          component: ManageAlertDelayedNotasEmailView,
        },

        {path: '/reports/delivery/movement', name: 'reportsDeliveryMovement', component: ReportsDeliveryMovementView},
        {path: '/reports/delivery/issue', name: 'reportsDeliveryIssue', component: ReportsDeliveryIssueView},
        {path: '/reports/delivery/checklist', name: 'reportsDeliveryChecklist', component: ReportsDeliveryChecklist},
        {path: '/reports/delivery/receiver', name: 'reportsDeliveryReceiver', component: ReportsDeliveryReceiverView},
        {path: '/reports/delivery/shipper', name: 'reportsDeliveryShipper', component: ReportsDeliveryShipperView},
        {path: '/reports/delivery/driver', name: 'reportsDeliveryDriver', component: ReportsDeliveryDriverView},
        {path: '/reports/delivery/month', name: 'reportsDeliveryMonth', component: ReportsDeliveryMonthView},
        {path: '/reports/delivery/period', name: 'reportsDeliveryPeriod', component: ReportsDeliveryPeriodView},
        {path: '/reports/delivery/vehicle', name: 'reportsDeliveryVehicle', component: ReportsDeliveryVehicleView},
        {path: '/reports/delivery/uf', name: 'reportsDeliveryUf', component: ReportsDeliveryUfView},
        {path: '/reports/delivery/canceled', name: 'reportsDeliveryCanceled', component: ReportsDeliveryCanceledView},
        {path: '/reports/delivery/alert', name: 'reportsDeliveryAlert', component: ReportsDeliveryAlertHistoryView},
        {
          path: '/reports/delivery/satisfaction-survey',
          name: 'reportsDeliverySatisfactionSurvey',
          component: ReportsDeliverySatisfactionSurveyHistoryView,
        },
        {path: '/reports/delivery/tracking', name: 'reportsDeliveryTracking', component: ReportsDeliveryTrackingView},
        {path: '/reports/delivery/audit', name: 'reportsDeliveryAudit', component: ReportsDeliveryAuditView},
        {path: '/reports/delivery/sla', name: 'reportsDeliverySla', component: ReportsDeliverySlaView},
        {path: '/reports/delivery/ended', name: 'reportsDeliveryEnded', component: ReportsDeliveryEndedView},
        {path: '/reports/delivery/sac', name: 'reportsDeliverySac', component: ReportsDeliverySacView},
        {
          path: '/reports/delivery/audit-delivery',
          name: 'reportsAuditByDelivery',
          component: ReportsAuditByDeliveryView,
        },
        {
          path: '/reports/delivery/client-notification',
          name: 'client-notification',
          component: ReportsClientNotificationView,
        },
        {path: '/css', component: CssUsageSampleView},
        {path: '/component', component: ComponentUsageSampleView},

        { path: '/manage/hide-responsavel-notas/list',
          name: 'manageHideResponsavelNotas',
          component: ManageHideResponsavelNotasListView,
        },
        { path: '/manage/hide-responsavel-notas/new',
          name: 'newHideTransporterNotas',
          component: HideResponsavelNotasPersistView,
        },
        { path: '/manage/hide-responsavel-notas/edit/:id',
          name: 'editHideTransporterNotas',
          component: HideResponsavelNotasPersistView,
          props: true,
        },
        { path: '/manage/audit-email/list',
          name: 'manageAuditEmail',
          component: ManageAuditEmailListView,
        },
        { path: '/manage/audit-email/new',
          name: 'newManageAuditEmail',
          component: AuditEmailPersistView,
        },
        { path: '/manage/audit-email/edit/:id',
          name: 'editManageAuditEmail',
          component: AuditEmailPersistView,
          props: true,
        },
        { path: '/manage/awaiting-audit-correction/list',
          name: 'manageAwaitingAuditCorrection',
          component: ManageAwaitingAuditCorrectionListView,
        },
        { path: '/manage/awaiting-audit-validation/list',
            name: 'manageAwaitingAuditValidation',
            component: ManageAwaitingAuditValidationView,
        },
        {
          path: '/manage/risk-area/list',
          name: 'manageRiskArea',
          component: ManageRiskAreaListView,
        },
        {
          path: '/manage/risk-area/edit/:id',
          name: 'editManageRiskArea',
          props: true,
          component: RiskAreaPersistView,
        },
        {
          path: '/manage/risk-area/new',
          name: 'newManageRiskArea',
          component: RiskAreaPersistView,
        },
        {
          path: '/manage/resp-user/list',
          name: 'manageRespUser',
          component: ManageRespUserListView,
        },
        {
          path: '/manage/resp-user/edit/:id',
          name: 'editManageRespUser',
          props: true,
          component: RespUserPersistView,
        },
        {
          path: '/manage/resp-user/new',
          name: 'newManageRespUser',
          component: RespUserPersistView,
        },
      ],
    },
    {path: '/', redirect: '/sign-in'},
    {path: '*', redirect: '/cockpit'},
  ],
}
